import Actions from "./userConstants";
import produce from "immer";

const initialState = {
  list: [],
  identityResult: null,
  operationResult: null,
  selected: null,
  loading: false,
  isDeleted: null,
  isDeleteLoading: false,
  bulkDeleteOperationResult: null,
  isBulkDeleting: false,
  legacy: {
    list: [],
    selected: null,
    loading: false,
    operationResult: null,
    selectedLoading: false,
    selectedRows: [],
  },
  selectedRows: [],
  settings: {
    loading: false,
    operationResult: null,
    status: null,
    formattedKey: null,
    qrBase64: null,
    qrLoading: false,
    loadingError: false,
  },
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.LIST_USERS:
      case Actions.CREATE_USER:
      case Actions.UPDATE_USER:
      case Actions.UNLOCK_USER:
      case Actions.CHANGE_PASSWORD:
        draft.loading = true;
        return draft;

      case Actions.LIST_USERS_SUCCEEDED:
        draft.loading = false;
        draft.list = action.payload.Data;
        return draft;

      case Actions.LIST_LEGACY_USERS:
        draft.legacy.loading = true;
        return draft;

      case Actions.DELETE_USER:
        draft.isDeleteLoading = true;
        return draft;
      case Actions.BULK_DELETE_USERS:
        draft.isBulkDeleting = true;
        return draft;

      case Actions.LIST_LEGACY_USERS_SUCCEEDED:
        draft.legacy.loading = false;
        draft.legacy.list = action.payload.Data;
        return draft;

      case Actions.UNLOCK_USER_SUCCEEDED:
        draft.identityResult = action.payload.Operation;
        draft.loading = false;
        return draft;

      case Actions.UPDATE_USER_SUCCEEDED:
      case Actions.CREATE_USER_SUCCEEDED:
        if (action.payload.Operation.Outcome === "Success") {
          draft.selected = action.payload.Data;
        }
        draft.operationResult = action.payload.Operation;
        draft.loading = false;
        return draft;

      case Actions.READ_USER:
        draft.selected = null;
        draft.operationResult = null;
        draft.loading = true;
        return draft;

      case Actions.READ_USER_SUCCEEDED:
        draft.selected = action.payload.Data;
        draft.operationResult =
          action.payload.Operation.Outcome !== "Success"
            ? action.payload.Operation
            : null;
        draft.loading = false;
        return draft;

      case Actions.DELETE_USER_SUCCEEDED:
        draft.isDeleteLoading = false;
        draft.operationResult = action.payload.Operation;
        draft.isDeleted = action.payload.Operation.Outcome == "Success";
        return draft;

      case Actions.BULK_DELETE_USERS_SUCCEEDED:
        draft.isBulkDeleting = false;
        draft.bulkDeleteOperationResult = action.payload.Operation;
        return draft;

      case Actions.CLEAR_BULK_DELETE_OPERATION_RESULT:
        draft.bulkDeleteOperationResult = null;
        draft.isBulkDeleting = false;
        return draft;

      case Actions.ACITVATE_LEGACY_USER:
        draft.legacy.loading = true;
        return draft;

      case Actions.ACITVATE_LEGACY_USER_SUCCEEDED:
        draft.legacy.loading = false;
        draft.legacy.operationResult = action.payload.Operation;
        return draft;

      case Actions.CLEAR_IDENTITY_OPERATION_RESULT:
        draft.identityResult = null;
        draft.loading = false;
        return draft;

      case Actions.CLEAR_OPERATION_RESULT:
        draft.operationResult = null;
        draft.isDeleted = null;
        return draft;

      case Actions.CLEAR_LEGACY_OPERATION_RESULT:
        draft.legacy.operationResult = null;
        return draft;

      case Actions.CLEAR_SELECTED_USER:
        draft.operationResult = null;
        draft.selected = null;
        draft.isDeleteLoading = false;
        draft.isDeleted = null;
        draft.isBulkDeleting = false;
        return draft;

      case Actions.CHANGE_PASSWORD_SUCCEEDED:
        draft.loading = false;
        draft.operationResult = action.payload.Operation;
        return draft;

      case Actions.SET_SELECTED_USER_ROWS:
        draft.selectedRows = action.payload.selectedRows;
        return draft;

      case Actions.CLEAR_SELECTED_USER_ROWS:
        draft.selectedRows = [];
        return draft;

      case Actions.SET_SELECTED_LEGACY_USER_ROWS:
        draft.legacy.selectedRows = action.payload.selectedRows;
        return draft;

      case Actions.CLEAR_SELECTED_LEGACY_USER_ROWS:
        draft.legacy.selectedRows = [];
        return draft;

      case Actions.SETTINGS_CLEAR_RESULT:
        draft.settings.operationResult = null;
        return draft;

      case Actions.SETTINGS_LOAD_STATUS:
      case Actions.SETTINGS_SET_PREFERRED_MFA:
      case Actions.SETTINGS_SET_PHONE_NUMBER:
      case Actions.SETTINGS_VERIFY_AUTHENTICATOR:
      case Actions.SETTINGS_RESET_AUTHENTICATOR:
        draft.settings.loading = true;
        return draft;

      case Actions.SETTINGS_LOAD_STATUS_SUCCEEDED:
        draft.settings.loading = false;
        draft.settings.status = action.payload.Data;
        draft.settings.loadingError =
          action.payload.Operation.Outcome !== "Success";
        return draft;

      case Actions.SETTINGS_SET_PREFERRED_MFA_SUCCEEDED:
      case Actions.SETTINGS_SET_PHONE_NUMBER_SUCCEEDED:
      case Actions.SETTINGS_VERIFY_AUTHENTICATOR_SUCCEEDED:
      case Actions.SETTINGS_RESET_AUTHENTICATOR_SUCCEEDED:
        draft.settings.loading = false;
        draft.settings.operationResult = action.payload.Operation;
        return draft;

      case Actions.SETTINGS_GET_AUTH_QR_START:
        draft.settings.qrLoading = true;
        draft.settings.qrBase64 = null;
        draft.settings.formattedKey = null;
        return draft;

      case Actions.SETTINGS_GET_AUTH_QR_SUCCESS:
        draft.settings.qrLoading = false;
        draft.settings.qrBase64 = action.payload.Data.PngBase64;
        draft.settings.formattedKey = action.payload.Data.FormattedKey;
        return draft;

      default:
        return state;
    }
  });
};
